import { createRouter, createWebHistory } from 'vue-router'
import { getToken, getTokenFromStorage } from '../utils/tool'
import store from '../store/index'
import Layout from '@/layout/index.vue';
import AppLayout from '../src/layout/home.vue'
import LayoutEmpyt from '../src/layout/empyt.vue'
import Index from '../src/pages/index.vue'
// import Order from '../src/pages/order/index.vue'
import Personal from '../src/pages/personal/index.vue'
import Login from '../src/pages/login.vue'
import Product from '../src/pages/product/index.vue'
import Kyc from '../src/pages/verify/kyc.vue'
import Face from '../src/pages/verify/active.vue'
import Base from '../src/pages/verify/base.vue'
import Work from '../src/pages/verify/work.vue'

import Contact from '../src/pages/verify/contact.vue'
// import Contact2 from '../src/pages/verify/contact2.vue'
import Callback from '../src/pages/verify/callback.vue'
import ProductDetail from '../src/pages/product/detail.vue'
import ProductDeny from '../src/pages/product/deny.vue'
import Bank from '../src/pages/bank/index.vue'
import bankAdd from '../src/pages/bank/add.vue'
import Ifsc from '../src/pages/bank/isfc.vue'

// import Schedule from '../src/pages/scheduled/index.vue'
import ScheduleDetail from '../src/pages/scheduled/detail.vue'

import Orders from '../src/pages/orders/index.vue'
import orderDetail from '../src/pages/orders/detail.vue'
import tryExtension from '../src/pages/orders/extension.vue'

import orderAudit from '../src/pages/orders/audit.vue'
import orderAudit2 from '../src/pages/orders/audit2.vue'
import orderConfirm from '../src/pages/orders/confirm.vue'
import Aboutus from '../src/pages/personal/about.vue'
import Help from '../src/pages/personal/help.vue'
import Download from '../src/pages/download.vue'
import Alert from '../src/pages/alert.vue'
import VerifyIndex from '../src/pages/verify/index.vue'
import FeedbackIndex from '../src/pages/feedback/index.vue'
import Test from '../src/pages/test.vue'
import Distribution from '../src/pages/distribute.vue'
import PromotionRegister from '../src/pages/promotion/register.vue'

import Empyt2 from '../src/layout/empty2.vue'
import DownloadLayout from '../src/layout/download.vue'
import ValidateIdCard from '../src/pages/verify/validateIdCard.vue'

import Safari from '../src/pages/download/safari.vue'
import Edge from '../src/pages/download/edge.vue'
import Chrome from '../src/pages/download/chrome.vue'
import Firefox from '../src/pages/download/firefox.vue'

import Terms from '../src/pages/protocol/term.vue'
import Privacy from '../src/pages/protocol/privacy.vue'
const routes = [
    {
        path:'/',
        name: 'Index',
        component: AppLayout,
        children:[
            {
                path:'',
                name: 'Home',
                component: Index,
                meta:{ title:'Index', bgcolor:'#fff' }
            },            
            {
                path:'personal',
                name: 'Personal',
                component: Personal,
                meta:{ title:'Personal', bgcolor:'#100F2F' }
            },
            {
              path:'order',
              name: 'order',
              component: Orders,
              meta:{ title:'Orders', bgcolor:'#100F2F' }
            }
        ]        
    },
    {
      path:'/protocol/term',
      name: 'term',
      component: Terms,
      meta:{ title:'Terms', bgcolor:'#fff' }
    },
    {
      path:'/protocol/privacy',
      name: 'privacy',
      component: Privacy,
      meta:{ title:'Privacy', bgcolor:'#fff' }
    },
    {
      path:'/feedback',
      name: 'Feedback',
      component: Layout,
      meta:{ title:'FeedBack', bgcolor:'#100F2F' },
      children:[
          {
              path:'',
              name: 'feedback',
              component: FeedbackIndex,
              meta:{ title:'FeedBack', bgcolor:'#100F2F' }
          }
      ]
    },
    {
      path:'/schedule/:oid',
      name: 'schedule_detail',
      component: ScheduleDetail,
      meta:{ title:'Scheduled Orders', bgcolor:'#fff' }
    },
    {
      path: '/joint',
      name: 'joint',
      component: Test,
      meta:{ title:'IvmCredit', bgcolor:'#fff' }
    },
    
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta:{ title:'Login', bgcolor:'#100F2F' }
    },
    {
      path: '/promotion/',
      name:"Promotion",
      component: LayoutEmpyt,
      children:[
        {
          path:"register",
          name: "register",
          component: PromotionRegister,
          meta:{ title:'register', bgcolor:'#F7F7F7' }
        },
        // {
        //   path:"amount",
        //   name: "amount",
        //   component: PromotionAmount,
        //   meta:{ title:'Congraluation', bgcolor:'#F7F7F7' }
        // },
      ]
    },
    {
      path: '/auth',
      name:"Verify",
      component: Layout,
      children:[
        {
          path:"index",
          name: "VerifyIndex",
          component: VerifyIndex,
          meta:{ title:'Index', bgcolor:'#F7F7F7' }
        },
        {
          path:"validateIdCard",
          name: "validateIdCard",
          component: ValidateIdCard,
          meta:{ title:'Verfify Aadhaar', bgcolor:'#100F2F' }
        },
        {
          path:"face",
          name: "Face",
          component: Face,
          meta:{ title:'Face Recognition', bgcolor:'#100F2F' }
        },
        {
          path:"identity",
          name: "identity",
          component: Kyc,
          meta:{ title:'Identity Verification', bgcolor:'#100F2F' }
        },
        {
          path:"basic",
          name: "Base",
          component: Base,
          meta:{ title:'Basic Infomation', bgcolor:'#100F2F' }
        },
        {
          path:"work",
          name: "work",
          component: Work,
          meta:{ title:'Work Information', bgcolor:'#100F2F' }
        },
        {
          path:"contacts",
          name: "Contact",
          component: Contact,
          meta:{ title:'Contact Information', bgcolor:'#100F2F' }
        },
        // {
        //   path:"contact2",
        //   name: "Contact2",
        //   component: Contact2,
        //   meta:{ title:'Contact', bgcolor:'#F7F7F7' }
        // },
        {
          path: "callback",
          name: "callback",
          component: Callback,
          meta:{ title:'Callback', bgcolor:'#fff' }
        }
      ]
    },
    {
      path:"/product",
      component:Layout,
      children:[
        {
          path: ':pid',
          name: 'Product',
          component: Product,
          meta:{ title:'Product', bgcolor:'#fff' }
        },    
        {
          path: ':pid/detail',
          name: 'Product-Detail',
          component: ProductDetail,
          meta:{ title:'Product Detail', bgcolor:'#100F2F' }
        }, 
        {
          path: ':pid/denied',
          name: 'Product-Denied',
          component: ProductDeny,
          meta:{ title:'Denied', bgcolor:'#100F2F' }
        },  
      ]
    },
      
    {
      path: '/bank',
      name: 'Bank',   
      component: Layout,   
      children:[
        {
          path:"",
          name: "Bank",
          component:Bank,
          meta:{ title:'Bank List', bgcolor:'#100F2F' }
        },
        {
          path:"add",
          name: "Bank_Add",
          component: bankAdd,
          meta:{ title:'Add Bank', bgcolor:'#100F2F' }
        },
        {
          path:"ifsc",
          name: "IFSC",
          component: Ifsc,
          meta:{ title:'IFSC', bgcolor:'#fff' }
        }         
      ]
    },  
    {
      path:"/orders/",
      name:'orders',
      component: Layout,
      meta:{ title:'Orders', bgcolor:'#F6F6F6'},
      children:[
        {
          path:"/orders/:id/extension",
          name:'Order_Extension',
          component: tryExtension,
          meta:{ title:'Extension', bgcolor:'#100F2F'}
        },
        {
          path:"/orders/:id/detail",
          name:'Order_Detail',
          component: orderDetail,
          meta:{ title:'Order Detail', bgcolor:'#100F2F'}
        },{
          path:"/orders/:id/audit",
          name:'Order_audit',
          component: orderAudit,
          meta:{ title:'Reviewing', bgcolor:'#100F2F'}
        },{
          path:"/orders/audit",
          name:'Order_auditt',
          component: orderAudit2,
          meta:{ title:'Auditing', bgcolor:'#fff'}
        },{
          path:"/orders/:id/confirm",
          name:'Order_confirm',
          component: orderConfirm,
          meta:{ title:'Confirmation', bgcolor:'#100F2F'}
        },
      ]
    },  
    
    {
      path: '/personal',
      name: 'personal',
      component:Layout,
      children:[
        {
          path:"aboutus",
          name:'aboutus',
          component: Aboutus,
          meta:{ title:'About Us', bgcolor:'#fff'}
        },{
          path:"help",
          name:'help',
          component: Help,
          meta:{ title:'Help', bgcolor:'#100F2F'}
        }
      ]
    },{
      path:"/download",
      name:'Download',
      component: DownloadLayout,
      meta:{ title:'Download', bgcolor:'#fff'},
      children:[
        {
          path:"",
          name:'download',
          component: Download,
          meta:{ title:'Download Guide', bgcolor:'#100F2F'}
        },
        {
          path:"safari",
          name:'safari',
          component: Safari,
          meta:{ title:'Download Guide - Safari', bgcolor:'#fff'}
        },{
          path:"chrome",
          name:'chrome',
          component: Chrome,
          meta:{ title:'Download Guide - Chrome', bgcolor:'#fff'}
        },{
          path:"firefox",
          name:'firefox',
          component: Firefox,
          meta:{ title:'Download Guide - Firefox', bgcolor:'#fff'}
        },{
          path:"edge",
          name:'edge',
          component: Edge,
          meta:{ title:'Download Guide - Edge', bgcolor:'#fff'}
        }
      ]

    },{
      path:"/alert",
      name:'Alert',
      component: Alert,
      meta:{ title:'Alert', bgcolor:'#fff'}
    },{
      path:"/distribution",
      name:'Distribution',
      component: Distribution,
      meta:{ title:'Distribution', bgcolor:'#fff'}
    },{
      path: '/promotion/',
      name:"Promotion",
      component: Empyt2,
      children:[
        {
          path:"register",
          name: "register",
          component: PromotionRegister,
          meta:{ title:'register', bgcolor:'#F7F7F7' }
        },        
      ]
    },
]
const router  = createRouter({
    history: createWebHistory('/'),
    routes
})
const whiteList = [
  '/promotion/register',
  '/login',
  '/download',
  "/download/safari",
  "/download/chrome",
  "/download/edge",
  "/download/firefox",
  '/download', '/alert', '/verify/contact2', '/orders/audit', '/joint', "/distribution"]
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : 'Index'    
    document.body.style.background = to.meta.bgcolor ? to.meta.bgcolor : '#fff'  
    document.body.parentElement.scrollTop = 0
    store.dispatch("setTitle", to.meta.title ? to.meta.title : 'Index')
    const hasToken = getToken() || getTokenFromStorage()   
    // alert(hasToken)   
    if (hasToken) {
      if (to.path === '/login') {        
        // next({ path: '/' })        
        next()
      } else {
        next()
      }
        
    } else {
      if (whiteList.indexOf(to.path) !== -1) {     
        next()        
      } else {
        let queryString = ""
        for(let x in to.query) {
          let content = to.query[x]
          if(x == 'adjust_referrer') {
            queryString += `&adjust_reftag=${content.replace("adjust_reftag=","")}`                
          } else {
            queryString += `&${x}=${content}`
          }              
        }       
        next(`/login?redirect=${to.path}${queryString}`)
        // NProgress.done()
      }
    }
  })
export default router